/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    title: 'I have a different issue',
    description: '<p>We are standing by and ready to help. Or you can find answers to most questions at the <a href="/customer-service">Customer Service Hub</a>.</p>',
    seo: {
        page_title: 'Customer Service Different Issue',
    },
};
export default data;
